// Admin-only "View as role" preview (role-based redesign). Lets an admin see
// any role's Home on /home without changing their actual grants — a pure
// presentation override resolved by HomePage. Persisted per-browser. 'admin' =
// the normal admin landing (Overview).

export type ViewAs = 'admin' | 'marketing' | 'product' | 'cs' | 'sales' | 'bdr';

const KEY = 'funnel:viewAs';
const VALUES: ViewAs[] = ['admin', 'marketing', 'product', 'cs', 'sales', 'bdr'];

export const VIEW_AS_LABEL: Record<ViewAs, string> = {
  admin: 'Exec / Admin',
  marketing: 'Marketing',
  product: 'Product',
  cs: 'Customer Success',
  sales: 'Sales',
  bdr: 'BDR',
};

export function getViewAs(): ViewAs {
  try {
    const v = localStorage.getItem(KEY) as ViewAs | null;
    return v && VALUES.includes(v) ? v : 'admin';
  } catch {
    return 'admin';
  }
}

export function setViewAs(v: ViewAs): void {
  try {
    localStorage.setItem(KEY, v);
  } catch {
    /* private mode */
  }
}

export const VIEW_AS_OPTIONS = VALUES;

// Short labels + order for the top-bar "View as" chip row (matches the mockup):
// personas first, Exec/Admin last.
export const VIEW_AS_SHORT: Record<ViewAs, string> = {
  admin: 'Exec',
  marketing: 'Marketing',
  product: 'Product',
  cs: 'CS',
  sales: 'Sales',
  bdr: 'BDR',
};
export const VIEW_AS_CHIP_ORDER: ViewAs[] = ['marketing', 'product', 'cs', 'sales', 'bdr', 'admin'];
